import { render, staticRenderFns } from "./AssetFromDashboard_pagination.vue?vue&type=template&id=00542682&scoped=true&"
import script from "./AssetFromDashboard_pagination.vue?vue&type=script&lang=js&"
export * from "./AssetFromDashboard_pagination.vue?vue&type=script&lang=js&"
import style0 from "./AssetFromDashboard_pagination.vue?vue&type=style&index=0&id=00542682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00542682",
  null
  
)

export default component.exports